"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Theme: true,
  ThemeProviderV2: true,
  ThemeProviderV3: true,
  useTheme: true,
  useThemeConfig: true,
  getThemeConfig: true,
  isThemeV2: true,
  isThemeV3: true,
  THEME_V2: true,
  THEME_V3: true,
  TextVariant: true
};
Object.defineProperty(exports, "THEME_V2", {
  enumerable: true,
  get: function get() {
    return _themes.THEME_V2;
  }
});
Object.defineProperty(exports, "THEME_V3", {
  enumerable: true,
  get: function get() {
    return _themes.THEME_V3;
  }
});
Object.defineProperty(exports, "TextVariant", {
  enumerable: true,
  get: function get() {
    return _types.TextVariant;
  }
});
exports.useThemeConfig = exports.useTheme = exports.isThemeV3 = exports.isThemeV2 = exports.getThemeConfig = exports.ThemeProviderV3 = exports.ThemeProviderV2 = exports.Theme = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledBootstrapGrid = require("styled-bootstrap-grid");

var _styledComponents = require("styled-components");

var _themes = require("./themes");

var _v = require("@artsy/palette-tokens/dist/themes/v2");

Object.keys(_v).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _v[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _v[key];
    }
  });
});

var _types = require("@artsy/palette-tokens/dist/typography/types");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // FIXME: Upgrading styled-components types to get `ThemeContext` breaks many other typings.
// Notably: `Icon` and `Sans|Serif`
// @ts-expect-error  MIGRATE_STRICT_MODE

/**
 * Creates a new Grid context for web. This glues the v2 grid theme into any other theme.
 */


var GridThemeProvider = function GridThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styledBootstrapGrid.GridThemeProvider, {
    gridTheme: _themes.THEME_V2.grid
  }, children);
};

GridThemeProvider.displayName = "GridThemeProvider";
var THEMES = {
  v2: _themes.THEME_V2,
  v3: _themes.THEME_V3
};
/**
 * A wrapper component for passing down the Artsy theme context
 */

var Theme = function Theme(_ref2) {
  var children = _ref2.children,
      _ref2$theme = _ref2.theme,
      themeOrThemeKey = _ref2$theme === void 0 ? _themes.THEME_V2 : _ref2$theme;
  var theme = themeOrThemeKey === "v2" || themeOrThemeKey === "v3" ? THEMES[themeOrThemeKey] : themeOrThemeKey;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(GridThemeProvider, null, children));
};

exports.Theme = Theme;
Theme.displayName = "Theme";
/** Utilize only the v2 theme */

var ThemeProviderV2 = function ThemeProviderV2(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _themes.THEME_V2
  }, children);
};

exports.ThemeProviderV2 = ThemeProviderV2;
ThemeProviderV2.displayName = "ThemeProviderV2";
/** Utilize only the v3 theme */

var ThemeProviderV3 = function ThemeProviderV3(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _themes.THEME_V3
  }, children);
};

exports.ThemeProviderV3 = ThemeProviderV3;
ThemeProviderV3.displayName = "ThemeProviderV3";
/** Returns the current theme */

var useTheme = function useTheme() {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return {
    theme: theme
  };
};
/** Returns a config specific to the current theme. For use in React components */


exports.useTheme = useTheme;

var useThemeConfig = function useThemeConfig(_ref5) {
  var v2 = _ref5.v2,
      v3 = _ref5.v3;

  var _useTheme = useTheme(),
      _useTheme$theme = _useTheme.theme,
      theme = _useTheme$theme === void 0 ? {
    id: "v2"
  } : _useTheme$theme;

  return theme.id === "v2" ? v2 : v3;
};
/** Returns a config specific to the current theme. For use in styled-components */


exports.useThemeConfig = useThemeConfig;

var getThemeConfig = function getThemeConfig(props, _ref6) {
  var v2 = _ref6.v2,
      v3 = _ref6.v3;
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {
    id: "v2"
  } : _props$theme;
  return theme.id === "v2" ? v2 : v3;
};
/** Typeguard for v2 */


exports.getThemeConfig = getThemeConfig;

var isThemeV2 = function isThemeV2(theme) {
  return theme.id === "v2";
};
/** Typeguard for v3 */


exports.isThemeV2 = isThemeV2;

var isThemeV3 = function isThemeV3(theme) {
  return theme.id === "v3";
};

exports.isThemeV3 = isThemeV3;